import React from 'react'
import shortid from 'shortid'
import { ControlledModal } from 'components/Modal/Modal'
import { TextInput } from 'components/Wizard2/fieldComponents/Form'
import { NodeEditor } from 'flume'
import config from './logicTypes/fieldFlumeConfig'
import TrashIcon from '@tecuity/sos-icons/react/trash'

export default ({
  name,
  value,
  allowCurrentRepeaterFields,
  allowCurrentField,
  parentField,
  onChange
}) => {
  const isRepeaterChild = parentField.parent.type === 'REPEATER'

  const addRule = () => {
    onChange(name, [
      ...value,
      {
        id: shortid.generate(),
        label: '',
        logicNodes: {},
        logicComments: {}
      }
    ])
  }

  const deleteRule = index => {
    onChange(name, [...value.slice(0, index), ...value.slice(index + 1)])
  }

  const setByKey = (key, index, newValue) => {
    onChange(name, [
      ...value.slice(0, index),
      {
        ...value[index],
        [key]: newValue
      },
      ...value.slice(index + 1)
    ])
  }

  const setLogic = (logicNodes, logicComments, index) => {
    onChange(name, [
      ...value.slice(0, index),
      {
        ...value[index],
        logicNodes,
        logicComments
      },
      ...value.slice(index + 1)
    ])
  }

  return (
    <div className="flex-column custom-business-rules">
      <p className="description">
        Custom business rules defined in this section will be applied when advancing to the next
        step and submitting the form.
      </p>
      {value.map((rule, i) => (
        <RuleRow
          {...rule}
          onLabelChange={value => setByKey('label', i, value)}
          onLogicChange={(nodes, comments) => {
            setLogic(nodes, comments, i)
          }}
          onRequestDelete={() => deleteRule(i)}
          allowCurrentRepeaterFields={isRepeaterChild ? true : allowCurrentRepeaterFields}
          allowCurrentField={allowCurrentField}
          hostFieldId={parentField.fieldId}
          parentFieldId={parentField.parent.id}
          key={rule.id}
        />
      ))}
      <button className="add-rule" onClick={addRule}>
        + Add New Rule
      </button>
    </div>
  )
}

const RuleRow = ({
  label,
  logicNodes,
  logicComments,
  onLabelChange,
  onLogicChange,
  onRequestDelete,
  allowCurrentRepeaterFields,
  allowCurrentField,
  hostFieldId,
  parentFieldId
}) => {
  const [logicEditorOpen, setLogicEditorOpen] = React.useState(false)
  const nodeEditor = React.useRef()

  const handleSave = () => {
    const nodes = nodeEditor.current.getNodes()
    const comments = nodeEditor.current.getComments()
    onLogicChange(nodes, comments)
  }

  return (
    <div className="flex-row custom-rule-row">
      <TextInput
        className="rule-label"
        value={label}
        onChange={onLabelChange}
        placeholder="Rule Label"
        ariaLabel="Rule Label"
      />
      <button className="btn btn-primary btn-raised" onClick={() => setLogicEditorOpen(true)}>
        Edit Logic
      </button>
      <button className="btn btn-danger btn-raised delete-button" onClick={onRequestDelete}>
        <TrashIcon />
      </button>
      <ControlledModal
        title={`${label.trim()} Logic`}
        size="fullscreen"
        isOpen={logicEditorOpen}
        onModalClosed={() => setLogicEditorOpen(false)}
        onRequestModalClose={() => setLogicEditorOpen(false)}
        saveAndCloseButton
        cancelButton
        closeButton={false}
        save={handleSave}
        cancel={() => {}}
        autoHeight={false}
        className=""
      >
        <div style={{ height: 'calc(100% - 51px)' }} className="logic-editor-wrapper">
          <NodeEditor
            nodeTypes={config.nodeTypes}
            portTypes={config.portTypes}
            nodes={logicNodes}
            comments={logicComments}
            context={{ allowCurrentRepeaterFields, allowCurrentField, hostFieldId, parentFieldId }}
            defaultNodes={[
              {
                type: `businessRuleOutput`,
                x: 400,
                y: -100
              }
            ]}
            ref={nodeEditor}
            debug
          />
        </div>
      </ControlledModal>
    </div>
  )
}
